export default "__VITE_ASSET__CM0rt$FR__"